import {Directive, Input} from '@angular/core';

@Directive({
    selector: '[cbTableStickyCol]',
    standalone: false
})
export class CbTableStickyColDirective {
    @Input() public cbTableStickyCol: 'start' | 'end' = 'end';
}
